export const capitalizeText = (text: string) => {
  const notValid = !text || text?.length === 0 || !text?.trim()
  if (notValid) return ''
  const normalize = text?.toLowerCase()?.trim()
  const textCapitalized =
    normalize?.charAt(0)?.toUpperCase() + normalize?.substring(1)

  return textCapitalized
}
